@if (context.visit) {
  @if (mobile) {
    <div>
      @if (authorizationsEnabled()) {
        <app-declaration-status tooltipTitle="Authorise Organisations" icon="fas fa-unlock-alt"
                                [status]="getAuthoriseStatus()" [link]="'/details/' + visit.crn + '/authorise'">
          Authorise Organisations
        </app-declaration-status>
      }
      @if (harbourDuesEnabled()) {
        <app-declaration-status tooltipTitle="Harbour Dues" [status]="harbourDuesStatus"
                                icon="fas fa-euro-sign" [link]="'/details/' + visit.crn + '/harbourDues'">
          Harbour Dues
        </app-declaration-status>
      }
      @if (visitInfoEnabled()) {
        <app-declaration-status [status]="$any(getVisitStatus() && !appContext.isCustoms())" tooltipTitle="Visit Information"
                                icon="fas fa-route" [link]="'/details/' + visit.crn + '/visit'">
          Visit Information
        </app-declaration-status>
      }
      @if (securityEnabled()) {
        <app-declaration-status tooltipTitle="Security" icon="fas fa-shield-alt" [status]="getSecurityStatus()"
                                [link]="'/details/' + visit.crn + '/security'">
          Security
        </app-declaration-status>
      }
      @if (crewEnabled()) {
        <app-declaration-status tooltipTitle="Crew and Passengers" icon="fas fa-address-card"
                                [status]="getStatus($any('PAX'))"
                                [link]="'/details/' + visit.crn + '/passengers'">
          Crew and Passengers
        </app-declaration-status>
      }
      @if (healthEnabled()) {
        <app-declaration-status tooltipTitle="Health declaration" icon="fas fa-medkit" [status]="getStatus($any('HEALTH'))"
                                [link]="'/details/' + visit.crn + '/health'">
          Health
        </app-declaration-status>
      }
      @if (wasteEnabled()) {
        <app-declaration-status tooltipTitle="Waste" icon="fas fa-recycle" [status]="getStatus($any('WASTE'))"
                                [link]="'/details/' + visit.crn + '/waste'">
          Waste
        </app-declaration-status>
      }
      @if (shipStoresEnabled()) {
        <app-declaration-status tooltipTitle="Ship Stores" icon="fas fa-wine-bottle" [status]="getStatus($any('STO'))"
                                [link]="'/details/' + visit.crn + '/shipStores'">
          Ship Stores
        </app-declaration-status>
      }
      @if (cargoImportEnabled()) {
        <div class="position-relative">
          <app-declaration-status tooltipTitle="Cargo Import" [status]="getStatus($any('SDT'))"
                                  icon="fas fa-caret-square-down"
                                  [link]="useNewCargoScreen ? ('/cargo/' + visit.crn) : ('/details/' + visit.crn + '/cargoImport')"
                                  [openInNewTab]="useNewCargoScreen">
            Cargo Import
          </app-declaration-status>
          @if (useNewCargoScreen) {
            <i class="position-absolute top-0 end-0 fa fa-arrow-up fa-rotate-by"
               style="--fa-rotate-angle: 45deg; font-size: 0.75rem; margin-right: 1px;" aria-hidden="true"></i>
          }
        </div>
      }
      @if (dangerousGoodsEnabled()) {
        <app-declaration-status tooltipTitle="Dangerous Goods" [status]="getStatus($any('DANGEROUS_GOODS'))"
                                icon="fas fa-burn"
                                [link]="getDangerousGoodsLink()">
          Dangerous Goods
        </app-declaration-status>
      }
    </div>
  } @else {
    <div class="navbar-expand justify-content-center d-none d-sm-block always-enabled" id="navbarNavDropdown">
      <ul class="navbar-nav">
        @if (authorizationsEnabled()) {
          <li
            class="nav-item border border-white rounded-start" title="Authorise Organisations">
            @if (context.isOrganisationCurrentVisitDeclarant()) {
              <app-declaration-status
                tooltipTitle="Authorise Organisations" icon="fas fa-unlock-alt"
                [status]="getAuthoriseStatus()" [link]="'/details/' + visit.crn + '/authorise'">
                Authorise Organisations
              </app-declaration-status>
            }
          </li>
        }
        @if (harbourDuesEnabled()) {
          <li class="nav-item border border-white border-start-0"
              title="Harbour Dues">
            <app-declaration-status tooltipTitle="Harbour Dues" [status]="harbourDuesStatus"
                                    icon="fas fa-euro-sign" [link]="'/details/' + visit.crn + '/harbourDues'">
              Harbour Dues
            </app-declaration-status>
          </li>
        }
        @if (visitInfoEnabled()) {
          <li class="nav-item border border-white border-start-0" title="Visit information">
            <div>
              <app-clearance-status [clearanceKey]="$any('ekh')"
                                    [declarationStatus]="getVisitStatus()"></app-clearance-status>
              <app-visit-declaration-status [visitDeclarationStatus]="getVisitStatus()"
                                            [terminalMessageStatus]="$any(getLeastTerminalMessageStatus())">
              </app-visit-declaration-status>
            </div>
          </li>
        }
        @if (securityEnabled()) {
          <li
            class="nav-item border border-white border-start-0" title="Security">
            <div>
              <app-clearance-status [clearanceKey]="$any('sspi')"
                                    [declarationStatus]="getSecurityStatus()"></app-clearance-status>
              <app-declaration-status tooltipTitle="Security" icon="fas fa-shield-alt" [status]="getSecurityStatus()"
                                      [link]="'/details/' + visit.crn + '/security'">
                Security
              </app-declaration-status>
            </div>
          </li>
        }
        @if (crewEnabled()) {
          <li class="nav-item border border-white border-start-0"
              title="Crew and passengers">
            <app-declaration-status tooltipTitle="Crew and passengers" icon="fas fa-address-card"
                                    [status]="getStatus($any('PAX'))" [link]="'/details/' + visit.crn + '/passengers'">
              Crew and Passengers
            </app-declaration-status>
          </li>
        }
        @if (healthEnabled()) {
          <li
            class="nav-item border border-white border-start-0" title="Health">
            <app-clearance-status [clearanceKey]="$any('mdoh')" [declarationStatus]="getStatus($any('HEALTH'))">
            </app-clearance-status>
            @if (appContext.isClearancesActive()) {
              <app-declaration-status tooltipTitle="Health" icon="fas fa-medkit"
                                      [status]="getStatus($any('HEALTH'))" [link]="'/details/' + visit.crn + '/health'">
                Health
              </app-declaration-status>
            }
            @if (!appContext.isClearancesActive()) {
              <app-declaration-status-health tooltipTitle="Health"
                                             icon="fas fa-medkit" [status]="getStatus($any('HEALTH'))"
                                             [hamisHealthStatus]="getHamisHealthStatus()"
                                             [link]="'/details/' + visit.crn + '/health'">
                Health
              </app-declaration-status-health>
            }
          </li>
        }
        @if (wasteEnabled()) {
          <li class="nav-item border border-white border-start-0" title="Waste">
            <div>
              <app-clearance-status [clearanceKey]="$any('emas')" [declarationStatus]="getStatus($any('WASTE'))">
              </app-clearance-status>
              <app-declaration-status tooltipTitle="Waste" icon="fas fa-recycle" [status]="getStatus($any('WASTE'))"
                                      [link]="'/details/' + visit.crn + '/waste'">
                Waste
              </app-declaration-status>
            </div>
          </li>
        }
        @if (shipStoresEnabled()) {
          <li
            class="nav-item border border-white border-start-0" title="Ship stores">
            <app-declaration-status tooltipTitle="Ship stores" icon="fas fa-wine-bottle" [status]="getStatus($any('STO'))"
                                    [link]="'/details/' + visit.crn + '/shipStores'">
              Ship Stores
            </app-declaration-status>
          </li>
        }
        @if (cargoImportEnabled()) {
          <li class="nav-item border border-white border-start-0 position-relative" title="Cargo import">
            <app-declaration-status tooltipTitle="Cargo import" [status]="getStatus($any('SDT'))"
                                    icon="fa fa-caret-square-down"
                                    [link]="useNewCargoScreen ? ('/cargo/' + visit.crn) : ('/details/' + visit.crn + '/cargoImport')"
                                    [openInNewTab]="useNewCargoScreen">
              Cargo Import
            </app-declaration-status>
            @if (useNewCargoScreen) {
              <i class="position-absolute top-0 end-0 fa fa-arrow-up fa-rotate-by"
                 style="--fa-rotate-angle: 45deg; font-size: 0.75rem; margin-right: 1px;" aria-hidden="true"></i>
            }
          </li>
        }
        @if (dangerousGoodsEnabled()) {
          <li
            class="nav-item border border-white border-start-0 rounded-end" title="Dangerous goods">
            <div>
              <app-clearance-status [clearanceKey]="$any('emgs')" [declarationStatus]="getStatus($any('DANGEROUS_GOODS'))">
              </app-clearance-status>
              <app-declaration-status tooltipTitle="Dangerous goods" [status]="getStatus($any('DANGEROUS_GOODS'))"
                                      icon="fas fa-burn" [link]="getDangerousGoodsLink()">
                Dangerous Goods
              </app-declaration-status>
            </div>
          </li>
        }
        <li class="nav-item dropdown ms-2">
          <a class="nav-link dropdown-toggle text-dark" href="#" id="navbarDropdownMenuLink" role="button"
             data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            More
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" style="z-index: 999999;">
            <!-- Support -->
            <a class="dropdown-item" [href]="appContext.supportPageForTask" target="_blank" tabindex="-1">
              <i class="fa fa-headset me-2" aria-hidden="true"
                 [title]="(appContext.supportPageTooltip | titlecase) + ' support'"></i>Support
            </a>
            <!-- Visit History/Activity -->
            <a class="dropdown-item" href="#" (click)="$event.preventDefault()"
               [routerLink]="['/details/' + visit.crn + '/history']">
              <i class="fas fa-history me-2" aria-hidden="true" title="Event history"></i>History
            </a>
            <!-- Downloads -->
            @if (!context.isOrganisationOnlyCargoDeclarant() &&
            (this.context.findLatestDeclaration(PAX) || this.context.findLatestDeclaration(STO)) ||
            this.displayNotificationOfDeparture()) {
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header" style="font-size: 17px;">
                <i class="fa fa-file-download me-1" aria-hidden="true"></i> Downloads
              </h6>
              @if ((this.context.findLatestDeclaration(PAX) || this.context.findLatestDeclaration(STO))
              && !context.isOrganisationOnlyCargoDeclarant() && !appContext.isCustoms()) {
                <a class="dropdown-item"
                   href="#" (click)="$event.preventDefault()">
                  <app-confirmation-of-purchase></app-confirmation-of-purchase>
                </a>
              }
              @if (this.displayNotificationOfDeparture() && !context.isOrganisationOnlyCargoDeclarant() &&
              !appContext.isCustoms() && !context.isAssignedFinancialDeclarant()) {
                <a class="dropdown-item" href="#" (click)="$event.preventDefault()">
                  <app-notification-of-departure></app-notification-of-departure>
                </a>
              }
            }
            <ng-container>
              <!-- Template downloads -->
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header" style="font-size: 17px;">
                Excel templates
              </h6>
              @if (securityEnabled()) {
                <a href="/assets/templates/security-declaration-template-v2.0.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Security
                </a>
              }
              @if (shipStoresEnabled()) {
                <a href="/assets/templates/sto-declaration-template-v1.1.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Ship stores
                </a>
              }
              @if (wasteEnabled()) {
                <a href="/assets/templates/waste-declaration-template-v2.1.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Waste
                </a>
              }
              @if (healthEnabled()) {
                <a href="/assets/templates/Maritime-Declaration-of-Health-template-v1.1.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Health
                </a>
              }
              @if (crewEnabled()) {
                <a href="/assets/templates/pax-declaration-template-small-v1.5.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Passengers (small)
                </a>
              }
              @if (crewEnabled()) {
                <a href="/assets/templates/pax-declaration-template-large-v1.5.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Passengers (large)
                </a>
              }
              @if (dangerousGoodsEnabled()) {
                <a href="/assets/templates/dangerous-goods-declaration-template-v1.0.xls" class="dropdown-item">
                  <i class="far fa-file-excel me-1" aria-hidden="true"></i> Dangerous goods
                </a>
              }
            </ng-container>
          </div>
        </li>
      </ul>
    </div>
  }
}
